<template>
	<section class="my-modal-custom">
		<div class="align-center">
			<div class="container-modal animate__animated animate__fadeInDown">
				<div class="box-modal">
					<div class="modal-title">
						<h1>Aprovar #{{ modalData.pgtoId }}</h1>
						<feather class="feather-icon" type="x" size="14" @click="$emit('close')" />
					</div>

					<div class="box-container">
						<div class="creditcardicon">
							<img
								v-if="inputError"
								class="creditCardAction animate__animated animate__shakeX"
								src="../../../assets/icons/credit-card-error.svg"
								alt="Credit card aprove"
							/>
							<img
								v-else
								class="creditCardAction"
								src="../../../assets/icons/credit-card.svg"
								alt="Credit card aprove"
							/>
						</div>
						<div class="list-collumn">
							<span class="title-label">
								Valor autorizado:<strong> R${{ parseFloat(modalData.valorAutorizado) }}</strong>
							</span>
						</div>
						<div class="list-collumn">
							<span class="title-label"> Valor a ser capturado: </span>
							<Input
								:border-focused="!inputError ? '#7159C7' : '#CC352D'"
								border-radius="5px"
								type="number"
								width="100%"
								height="30px"
								:is-disable="false"
								:format-money="true"
								margin-top="10px"
								:value="parseFloat(modalData.valorFinalPedido)"
								@value="changeValue($event)"
								@validate-error="handleError($event)"
							/>
							<div class="error-message">
								<p>{{ error.message }}</p>
							</div>
						</div>
					</div>
				</div>

				<div v-if="!inputError" class="confirmButton" @click="$emit('confirm', inputValue)">
					Confirmar
				</div>
				<div v-else class="cancelbutton" @click="$emit('close')">Cancelar</div>
			</div>

			<div />
		</div>
	</section>
</template>

<script>
import Input from '../input/default';

export default {
	components: {
		Input,
	},
	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		modalData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			inputError: false,
			inputValue: '',
			error: {
				message: null,
				status: false,
			},
		};
	},

	methods: {
		handleError(error) {
			this.inputError = error.status;
			this.error.message = error.message;
		},
		changeValue(value) {
			if (value) {
				this.inputValue = parseFloat(value);
				// eslint-disable-next-line no-restricted-globals
				if (this.inputValue > parseFloat(this.modalData.valorAutorizado, 10)) {
					this.inputError = true;
					this.error.message = 'Valor maior que o valor autorizado';
				} else if (this.inputValue <= 0) {
					this.inputError = true;
					this.error.message = 'Valor não permitido';
				} else {
					this.inputError = false;
					this.error.message = null;
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.error-message {
	margin-bottom: 5px;
	margin-top: 3px;
}
.error-message p {
	font-size: 12px;
	margin-bottom: 5px;
	font-weight: bold;
	color: #cc352d;
}
.list-collumn {
	width: 250px;
	display: flex;
	align-items: flex-start;
	flex-direction: column;
}
.creditCardAction {
	transition: 150ms ease-in-out;
}
.title-label {
	margin-bottom: 2px;
	margin-top: 15px;
}
.creditcardicon {
	width: 50%;
	padding-bottom: 10px;
}
.inline-item {
	display: flex;
	align-items: flex-start;
}
.inline-item span {
	font-size: 12px;
	margin-right: 4px;
}
.align-center {
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}

.my-modal-custom {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.24);
	display: table;
	transition: all 0.5s ease;
	overflow-y: scroll;
	align-items: flex-end;
}

.feather-icon {
	background-color: #ff3b30;
	padding: 2px;
	border-radius: 50%;
	color: #fff;
	cursor: pointer;
	transition: 300ms ease;
}

.feather-icon:hover {
	background-color: #cc342c;
}

.box-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	justify-content: center;
}

.modal-title {
	width: 100%;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	/*    border-bottom: 1px solid #dfdfe1c5; */
}
.modal-title h1 {
	font-weight: bold;
}

.container-modal {
	position: absolute;
	width: 400px;
	border-radius: 5px;
}

.box-modal {
	background-color: #fff;
	width: 100%;
	display: flex;
	flex-direction: column;
	height: 90%;
	padding-bottom: 50px;
	border-radius: 10px;
}

.cancelbutton {
	background-color: #cc352d;
	padding: 10px;
	margin-top: 10px;
	border-radius: 10px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	transition: 500ms ease;
	font-size: 14px;
}

.cancelbutton:hover {
	background-color: #9c2c26;
}

.confirmButton {
	background-color: #007f00;
	padding: 10px;
	margin-top: 10px;
	border-radius: 10px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	transition: 500ms ease;
	font-size: 14px;
}

.confirmButton:hover {
	background-color: #005700;
}
</style>
